/** German texts of the module, below its ID: `fire-safety.nav.inspections`. */
export const de = {
  name: 'Brandschutzbeauftragter',
  description:
    'Begehungen von Objekten mit Feststellungen, Fotos, Anhängen und Bericht, auch ohne Netz.',
  nav: { inspections: 'Begehungen' },
  entities: { inspection: 'Begehung' },
  permissions: {
    inspection: {
      read: {
        label: 'Begehungen ansehen',
        description:
          'Begehungen mit Feststellungen, Fotos und Anhängen öffnen und Berichte erzeugen. Mit Umfang „Eigene“ nur Begehungen, bei denen die Person Begeher ist oder die sie angelegt hat.',
      },
      write: {
        label: 'Begehungen bearbeiten',
        description:
          'Begehungen anlegen und ändern, Feststellungen und Fotos erfassen, Anhänge hochladen. Mit Umfang „Eigene“ nur eigene Begehungen.',
      },
      delete: {
        label: 'Begehungen löschen',
        description: 'Begehungen mit ihren Feststellungen, Fotos und Anhängen löschen.',
      },
      comment: {
        label: 'Begehungen kommentieren',
        description: 'Kommentare an Begehungen schreiben.',
      },
      export: {
        label: 'Begehungen exportieren',
        description: 'Die Liste der Begehungen als CSV-Datei herunterladen.',
      },
    },
    settings: {
      manage: {
        label: 'Brandschutz einrichten',
        description:
          'Mängelkatalog, Kategorien, Berichtsvorlagen und Fragebögen der Firma pflegen und die Einstellungen des Moduls ändern.',
      },
    },
  },
  roles: {
    inspector: 'Brandschutzbeauftragter: Begehungen durchführen',
    manager: 'Brandschutzbeauftragter: Begehungen verwalten',
  },
  settings: {
    offlineDays: {
      label: 'Abgeschlossene Begehungen offline (Tage)',
      description:
        'So lange nach „Protokoll versendet“ bleiben Begehungen auf den Geräten ihrer Begeher. Bei 0 nur offene Begehungen.',
    },
  },
  offline: { inspections: 'Begehungen' },
  documents: {
    inspectionReport: 'Begehungsbericht',
    groups: {
      object: 'Objekt',
      customer: 'Kunde',
      inspection: 'Begehung',
      findings: 'Feststellungen',
    },
    placeholders: {
      object: {
        name: 'Bezeichnung',
        number: 'Objektnummer',
        customerNumber: 'Objektnummer des Kunden',
        address: 'Adresse',
        street: 'Straße und Hausnummer',
        postcode: 'PLZ',
        city: 'Ort',
        state: 'Bundesland',
        usage: 'Nutzung',
        buildingClass: 'Gebäudeklasse',
      },
      customer: {
        name: 'Name',
        number: 'Kundennummer',
        address: 'Adresse',
        phone: 'Telefon',
        email: 'E-Mail',
        website: 'Website',
        contact: 'Ansprechpartner',
      },
      inspection: {
        title: 'Bezeichnung',
        date: 'Datum',
        inspectors: 'Begeher',
        participants: 'Weitere Teilnehmer',
        attendees: 'Anwesende',
        status: 'Status',
        remarks: 'Bemerkungen',
      },
      findings: { count: 'Anzahl gesamt', open: 'Anzahl offen' },
    },
    sources: { attendees: 'Anwesende', remarks: 'Bemerkungen' },
  },
  ai: { findingDraft: 'Mangel aus Stichpunkten formulieren' },
  questionnaires: { general: 'Allgemeine Angaben' },
  statuses: {
    planned: 'Geplant',
    'in-progress': 'Laufend',
    completed: 'Protokoll versendet',
  },
  audit: {
    inspection: {
      create: 'Begehung angelegt',
      update: 'Begehung geändert',
      start: 'Begehung gestartet',
      complete: 'Protokoll versendet',
      reopen: 'Begehung wieder geöffnet',
      delete: 'Begehung gelöscht',
    },
  },
  guides: {
    inspections: {
      title: 'Begehungen',
      summary: 'Begehungen planen, durchführen und abschließen, und wer was darf.',
    },
  },
  errors: {
    object: 'Bitte ein Objekt wählen, das in Projekte verfügbar und nicht archiviert ist.',
    project:
      'Bitte ein Projekt der Firma wählen, das du sehen darfst und das nicht archiviert ist.',
    projectObject: 'Das Objekt gehört nicht zu diesem Projekt.',
    title: 'Bitte eine Bezeichnung eingeben (höchstens 200 Zeichen).',
    date: 'Bitte ein gültiges Datum eingeben.',
    inspector: 'Bitte aktive Konten der Firma als Begeher wählen.',
    inspectors: 'Höchstens 20 Begeher, jede Person einmal.',
    participants: 'Die weiteren Teilnehmer dürfen höchstens 1000 Zeichen lang sein.',
    attendee:
      'Jede anwesende Person braucht einen Namen. Name und Funktion: höchstens 200 Zeichen.',
    attendees: 'Höchstens 100 anwesende Personen.',
    remarks: 'Die Bemerkungen dürfen höchstens 20.000 Zeichen lang sein.',
    attachment:
      'Anhänge sind PDF-Dateien dieser Begehung, jede mit einer Bezeichnung (höchstens 200 Zeichen).',
    attachments: 'Höchstens 50 Anhänge, jede Datei einmal.',
    completedAt: 'Bitte einen Zeitpunkt angeben, der nicht in der Zukunft liegt.',
    status: 'Im aktuellen Status der Begehung geht das nicht. Bitte die Seite neu laden.',
    completed:
      'Das Protokoll ist versendet. Erst nach „Wieder öffnen“ lassen sich Mängel erfassen.',
  },
  report: {
    title: 'Begehungsbericht {{object}}',
    inspector: 'Begeher {{number}}',
    attendeeName: 'Name',
    attendeeRole: 'Funktion',
    checks: {
      questionnaire: 'Allgemeine Angaben: {{open}} Fragen ohne Antwort.',
      attendees: 'Es sind keine Anwesenden eingetragen.',
      remarks: 'Es sind keine Bemerkungen eingetragen.',
    },
    sample: {
      remarks: 'Zweiter Rettungsweg im Obergeschoss vor Ort mit der Hausmeisterin besprochen.',
    },
  },
  sections: { inspections: 'Brandschutzbegehungen' },
  pages: {
    unavailable: 'nicht verfügbar',
    offlinePerson: 'Name nur mit Verbindung',
    errors: {
      versionConflict:
        'Die Begehung wurde inzwischen geändert. Die Seite zeigt jetzt den neuen Stand; bitte die Änderung wiederholen.',
      invalidInput: 'Bitte die Angaben prüfen.',
      notFound: 'Die Begehung gibt es nicht mehr.',
      forbidden: 'Dafür fehlt die Berechtigung.',
    },
    list: {
      title: 'Begehungen',
      description: 'Brandschutzbegehungen in den Objekten der Firma, die neuesten zuerst.',
      search: 'Begehungen durchsuchen',
      searchPlaceholder: 'Bezeichnung, Objekt oder Projekt',
      exportName: 'Brandschutzbegehungen',
      offline: 'Ohne Verbindung: Begehungen auf diesem Gerät',
      allStatuses: 'Alle Status',
      allObjects: 'Alle Objekte',
      allProjects: 'Alle Projekte',
      allInspectors: 'Alle Begeher',
      from: 'Datum von',
      to: 'Datum bis',
      noMatches: 'Keine passenden Begehungen',
      noMatchesHint: 'Suche oder Filter ändern.',
      empty: 'Noch keine Begehungen',
      emptyHint: 'Mit „Begehung starten“ die erste Begehung anlegen.',
      emptyReadOnly: 'Angelegte Begehungen erscheinen hier.',
      findings: '{{open}} / {{total}}',
      columns: {
        title: 'Bezeichnung',
        status: 'Status',
        object: 'Objekt',
        project: 'Projekt',
        date: 'Datum',
        inspectors: 'Begeher',
        findings: 'Mängel offen / gesamt',
      },
    },
    section: {
      date: 'Datum',
      title: 'Bezeichnung',
      object: 'Objekt',
      status: 'Status',
      openFindings: 'Offene Mängel',
      empty: 'Noch keine Brandschutzbegehungen',
      emptyHint: 'Mit „Begehung starten“ die erste Begehung hier anlegen.',
      emptyReadOnly: 'Angelegte Brandschutzbegehungen erscheinen hier.',
    },
    start: {
      action: 'Begehung starten',
      title: 'Begehung starten',
      planTitle: 'Begehung planen',
      description: 'Liegt das Datum in der Zukunft, wird die Begehung geplant.',
      submit: 'Starten',
      plan: 'Planen',
      started: 'Begehung gestartet',
      planned: 'Begehung geplant',
      copyFailed: 'Die Begehung ist angelegt, die Mängel ließen sich nicht übernehmen.',
      offlineUnavailable:
        'Ohne Verbindung lassen sich Begehungen nur anlegen, wenn das Gerät Brandschutzbegehungen offline hält.',
      object: 'Objekt',
      objectPlaceholder: 'Objekt auf diesem Gerät wählen',
      objectHint: 'Projekt und Kunde ergeben sich aus dem Objekt.',
      projectObjectHint: 'Eines der Objekte des Projekts.',
      projectObjectPlaceholder: 'Objekt des Projekts wählen',
      noObjects: 'Das Projekt hat keine Objekte',
      noObjectsHint:
        'Eine Begehung findet an einem Objekt statt. Ordne dem Projekt unter „Objekte“ ein Objekt zu, dann lässt sich die Begehung starten.',
      projectClosed: 'Projekt nicht offen',
      projectClosedHint:
        'Begehungen lassen sich nur in offenen Projekten der eigenen Firma starten, nicht in abgeschlossenen, stornierten oder archivierten.',
      project: 'Projekt',
      projectLoading: 'Projekt wird ermittelt',
      noProject: 'Kein offenes Projekt am Objekt',
      noProjectHint:
        'Eine Begehung gehört immer zu einem Projekt. Ordne das Objekt unter Projekte einem laufenden Projekt zu, dann lässt sich die Begehung starten.',
      projectChoice: 'Am Objekt laufen mehrere offene Projekte. Zu welchem gehört die Begehung?',
      projectPlaceholder: 'Projekt wählen',
      projectRequired: 'Bitte das Projekt der Begehung wählen.',
      otherProject: 'Anderes Projekt wählen',
      customer: 'Kunde',
      noCustomer: 'Am Projekt ist kein Auftraggeber eingetragen.',
      titleField: 'Bezeichnung',
      titleHint: 'Ohne Angabe „Begehung“ mit dem Datum.',
      date: 'Datum',
      dateHint: 'Ein Datum in der Zukunft plant die Begehung.',
      template: 'Allgemeine Angaben',
      templatesUnavailable:
        'Die Vorlagen der Allgemeinen Angaben sind nicht auf dem Gerät. Die Begehung beginnt ohne Fragebogen.',
      copy: 'Mängel aus einer früheren Begehung übernehmen',
      copyFrom: 'Frühere Begehung',
      copyNone: 'Keine übernehmen',
      closedFinding: 'erledigt',
      positiveFinding: 'positiv',
      copyOffline: 'Mängel lassen sich nur mit Verbindung übernehmen.',
    },
    detail: {
      notFound: 'Begehung nicht gefunden',
      notFoundHint: 'Sie wurde gelöscht, oder die Berechtigung fehlt.',
      notOnDevice: 'Begehung nicht auf diesem Gerät',
      notOnDeviceHint:
        'Ohne Verbindung öffnet die App nur Begehungen, die auf dem Gerät liegen. Öffne sie vorher einmal mit Verbindung.',
      onlineOnly: 'Ohne Verbindung nicht verfügbar',
      onlineOnlyHint:
        'In dieser Firma hält dein Gerät nichts offline, etwa weil du als Superadmin in einer anderen Firma als deiner eigenen arbeitest.',
      report: 'Bericht erstellen',
      steps: {
        start: 'Starten',
        complete: 'Protokoll versendet',
        reopen: 'Wieder öffnen',
        startDone: 'Begehung gestartet',
        completeDone: 'Als versendet markiert',
        reopenDone: 'Begehung wieder geöffnet',
      },
      deleted: '„{{title}}“ gelöscht',
      offlineRefused: 'Eine Änderung auf diesem Gerät wurde abgelehnt',
      offlineRefusedHint:
        'Grund: {{reason}}. Details und Verwerfen im Fenster „Synchronisierung“ in der oberen Leiste.',
      completedTitle: 'Protokoll versendet',
      completedSince:
        'Seit {{when}}. Angaben, Feststellungen und Anhänge ändern sich erst nach „Wieder öffnen“, Kommentare gehen weiter.',
      objectPlans: 'Pläne des Objekts',
      projectPlans: 'Pläne des Projekts',
      noFinding: 'Laut KI vermutlich kein Mangel: {{reason}}',
      noPositive: 'Laut KI vermutlich nichts Positives: {{reason}}',
      plansHint: 'Pläne des Objekts und des Projekts. Feststellungen lassen sich darauf verorten.',
      deleteTitle: 'Begehung löschen?',
      deleteDescription: '„{{title}}“ wird gelöscht.',
      deleteHeavy:
        '„{{title}}“ wird mit {{findings}} Feststellungen, {{files}} Dateien und den Kommentaren gelöscht. Das lässt sich nicht rückgängig machen.',
      deleteWord: 'LÖSCHEN',
      deleteWordLabel: 'Zum Bestätigen LÖSCHEN eingeben',
      questionnaire: 'Allgemeine Angaben',
      noQuestionnaire: 'Keine Allgemeinen Angaben.',
      attendees: 'Anwesende',
      attendeeName: 'Name',
      attendeeRole: 'Funktion',
      addAttendee: 'Person hinzufügen',
      attendeeRow: 'Anwesende Person {{number}}',
      removeAttendee: 'Anwesende Person {{number}} entfernen',
      noAttendees: 'Noch keine Anwesenden.',
      none: 'Keine Angabe.',
      notes: 'Teilnehmer und Bemerkungen',
      participants: 'Weitere Teilnehmer',
      participantsHint: 'Etwa Vertreter des Auftraggebers oder der Feuerwehr.',
      remarks: 'Bemerkungen',
      reportAttachments: 'Anhänge im Bericht',
      reportAttachmentsHint:
        'PDF-Dateien der Begehung, die hinter den Bericht kommen, in dieser Reihenfolge.',
      noReportAttachments: 'Noch keine Anhänge im Bericht.',
      moveUp: '„{{name}}“ nach oben',
      moveDown: '„{{name}}“ nach unten',
      removeFromReport: '„{{name}}“ aus dem Bericht nehmen',
      addToReport: '„{{name}}“ anhängen',
      editTitle: 'Begehung bearbeiten',
      inspectors: 'Begeher',
      inspectorsOffline: 'Begeher lassen sich nur mit Verbindung ändern.',
      sections: 'Abschnitte der Begehung',
      tabs: {
        findings: 'Mängel',
        questionnaire: 'Fragebogen',
        protocol: 'Protokoll',
        plans: 'Pläne',
        files: 'Dateien',
        history: 'Verlauf',
      },
      openFindings: '{{count}} offen',
      meta: {
        date: 'Datum',
        object: 'Objekt',
        project: 'Projekt',
        customer: 'Kunde',
        inspectors: 'Begeher',
      },
    },
  },
};
